import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import LearnIndex from "@/pages/learn/page";
import LearnDetail from "@/pages/learn/detail/page";
import GuidesIndex from "@/pages/guides/page";
import GuideDetail from "@/pages/guides/detail/page";
import Blog from "@/pages/blog/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/learn",
    element: <LearnIndex />,
  },
  {
    path: "/learn/:slug",
    element: <LearnDetail />,
  },
  {
    path: "/guides",
    element: <GuidesIndex />,
  },
  {
    path: "/guides/:slug",
    element: <GuideDetail />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/preparation",
    element: <Navigate to="/learn" replace />,
  },
  {
    path: "/guide",
    element: <Navigate to="/guides" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;